import { useNavigate, useLocation } from 'react-router-dom';

export function UseNavitageToPage(){
    const navigate = useNavigate();
    const location = useLocation();

    const NavigateToPageFromPageName = (pageName, sessionId) =>{
        //console.log( `Logging data from navigate: `, pageName, sessionId);
        let sessionCode = sessionStorage.getItem("sessionCode");
        

        switch (pageName.toLowerCase()) {
            case "hockey":
                navigate(`/Hockey?code=${sessionCode}`);
                break;
            case "shuffleboard":
                navigate(`/ShuffleBoard?code=${sessionCode}`);
                break;
            case "paperfootball":
                navigate(`/PaperFootball?code=${sessionCode}`);
                break;
            case "sumo":
                navigate(`/Sumo?code=${sessionCode}`);
                break;
            case "soccer":
                navigate(`/Soccer?code=${sessionCode}`);
                break;
            case "golf":
                navigate(`/Golf?code=${sessionCode}`);
                break;
            case "monstertruck":
                navigate(`/MonsterTruck?code=${sessionCode}`);
                break;
            case "chuckit":
                navigate(`/ChuckIt?code=${sessionCode}`);
                break;
            case "aquarium":
                navigate(`/Aquarium?code=${sessionCode}`);
                break;
            default:
                // Handle default case or throw error for invalid pageName
                navigate(`/Lobby?code=${sessionCode}`);
                break;
        }
    }

    const tryNavigatePage = (payload, playerId, sessionId) => {
        //console.log(`I am in the nav to page method`, payload);
        
        if(getCurrentPage() != payload.additionalData){
            //console.log("Page was diff");
            if(payload.targetPlayerGUID === playerId){
                //console.log("Its me and now trying to go to correct page");
                NavigateToPageFromPageName(payload.additionalData, sessionId)
            }
        }
    }

    function getCurrentPage() {
        const pathname = location.pathname;
    
        // Split the pathname by '/' and get the first segment
        const initialPath = pathname.split('/')[1];
    
        return initialPath;
    }

    return {NavigateToPageFromPageName, tryNavigatePage};
}


